module.exports = __webpack_public_path__ + "img/tech_contact_txt.98cc9b55.png";